var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresenter = function SvgPresenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 486 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.934C0 8.747 8.637.498 19.312.498h452.382c8.253 0 11.827 5.013 3.335 7.338-48.893 12.716-78.401 41.02-94.378 60.891-11.564 14.813-28.909 43.55-37.857 58.75-3.167 5.583-3.959 8.842 4.918 4.535l1.919-.957c18.665-9.207 54.842-26.23 87.205-36.6 47.621-15.245 56.018 14.768 43.447 35.004-9.86 15.861-116.402 157.471-162.079 218.044-5.71 7.52-7.917 8.5-19.025 8.5H19.312C8.661 356.003 0 347.753 0 337.589V18.934Z",
    fill: "url(#presenter_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "presenter_svg__a",
    x1: 544.5,
    y1: -81.25,
    x2: 325.853,
    y2: 344.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#205257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#205257",
    stopOpacity: 0
  })))));
};
export default SvgPresenter;